import { Type } from 'class-transformer';
import { VendorHeaderTemplateRawDto } from './vendor-header-template-raw-dto';
import { VendorLineItemCodingTemplateRawDto } from './vendor-line-item-coding-template-raw-dto';

export class WFVendorCodingDefaultTemplateParametersDto {
    workflowId: number;
    communityVendorId: number;
    vendorAccountId: number;
    payeeCode: string;
    communityId: number;

    @Type(() => VendorHeaderTemplateRawDto)
    headerTemplate: VendorHeaderTemplateRawDto;

    @Type(() => VendorLineItemCodingTemplateRawDto)
    lineItemTemplates: Array<VendorLineItemCodingTemplateRawDto>;
}
